import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { commonPageFieldList, commonPageFieldListSuccess, GetVenderSupplierCustomer, GetVenderSupplierCustomerSuccess } from "../../../store/actions";
import * as pageId from "../../../routes/allPageID"
import * as url from "../../../routes/route_url";
import * as _cfunc from "../../../components/Common/CommonFunction";
import CommonPurchaseList from "../../../components/Common/CommonPurchaseList";
import { Go_Button, PageLoadingSpinner } from "../../../components/Common/CommonButton";
import { Col, FormGroup, Label, Row } from "reactstrap";
import { C_DatePicker } from "../../../CustomValidateForm";
import StockEntry from "./StockEntry";
import { GetStockEntryList_Action, GetStockEntryView_Action } from "../../../store/Inventory/StockEntryRedux/action";
import StockEntryView from "./StockEntryView";
import * as _act from "../../../store/Inventory/StockEntryRedux/action";
import { C_Select } from "../../../CustomValidateForm";
import { allLabelWithZero } from "../../../components/Common/CommonErrorMsg/HarderCodeData";

const StockEntryList = () => {

    const dispatch = useDispatch();
    const currentDate_ymd = _cfunc.date_ymd_func();
    const [headerFilters, setHeaderFilters] = useState('');
    // const IsMannagementParty = !_cfunc.loginUserIsFranchisesRole() && _cfunc.loginIsSCMParty() && _cfunc.loginUserAdminRole();
    const IsMannagementParty = _cfunc.isAdminDivisionRole();
    const [PartyDropdown, setPartyDropdown] = useState(allLabelWithZero);

    const reducers = useSelector(
        (state) => ({
            listBtnLoading: state.StockEntryReducer.listBtnLoading,
            tableList: state.StockEntryReducer.StockEntryList,
            goBtnLoading: state.StockEntryReducer.listGoBtnloading,
            deleteMsg: state.StockEntryReducer.deleteMsg,
            userAccess: state.Login.RoleAccessUpdateData,
            partyDropdownLoading: state.CommonPartyDropdownReducer.partyDropdownLoading,
            pageField: state.CommonPageFieldReducer.pageFieldList,
            Party: state.CommonPartyDropdownReducer.commonPartyDropdownOption
        })

    );
 
    const { commonPartyDropSelect } = useSelector((state) => state.CommonPartyDropdownReducer);
    const { pageField, goBtnLoading, partyDropdownLoading, Party } = reducers
    const { fromdate = currentDate_ymd, todate = currentDate_ymd } = headerFilters;

    const action = {
        deleteId: (inx) => {

            const detail = inx.rowData
            const jsonBody = JSON.stringify({
                PartyID: detail.Party_id,
                StockDate: detail.PriviousStockDate
            });
            return _act.deleteStockEntry({ jsonBody });
        },
        deleteSucc: _act.deleteStockEntry_Success,

    };

    useEffect(() => {
        dispatch(GetVenderSupplierCustomerSuccess([]));
        dispatch(GetVenderSupplierCustomer({ subPageMode: url.STOCK_ENTRY_LIST, PartyID: _cfunc.loginSelectedPartyID() }));
        return () => {
            dispatch(GetVenderSupplierCustomerSuccess([]));
        }
    }, []);

    useEffect(() => {
        const page_Id = pageId.STOCK_ENTRY_LIST;
        dispatch(commonPageFieldList(page_Id));
        return () => {
            dispatch(commonPageFieldListSuccess(null));
        }
    }, []);

    useEffect(() => {
        if (commonPartyDropSelect.value > 0) {
            goButtonHandler();

        } else {
            dispatch(_act.GetStockEntryList_Success([]));
        }
    }, [commonPartyDropSelect]);


    const goButtonHandler = (Type) => {
        try {
            const jsonBody = JSON.stringify({
                "FromDate": fromdate,
                "ToDate": todate,
                "PartyID": (IsMannagementParty && PartyDropdown)
                    ? PartyDropdown.value
                    : _cfunc.loginSelectedPartyID(),
                "EmployeeID": _cfunc.loginEmployeeID(),
                "IsStockAdjustment": 0
            });
            dispatch(GetStockEntryList_Action({ jsonBody, Type }));
        } catch (error) {
            console.error("Error fetching stock entry list:", error);
        }
    };


    function fromdateOnchange(e, date) {
        let newObj = { ...headerFilters }
        newObj.fromdate = date
        setHeaderFilters(newObj)
    }

    function todateOnchange(e, date) {
        let newObj = { ...headerFilters }
        newObj.todate = date
        setHeaderFilters(newObj)
    }

    function viewApprovalBtnFunc(config) {

        const jsonBody = JSON.stringify({
            "PartyID": config.rowData.Party_id,
            "StockDate": config.rowData.PriviousStockDate,
            "IsStockAdjustment": 0
        })
    
        dispatch(GetStockEntryView_Action({
            jsonBody,
            ItemCount: config.rowData.ItemCount,
            btnId: `btn-viewApproval-${config.rowData.id}`
        }))
    }

    const Party_Option =
        Party && Array.isArray(Party)
            ? [
                allLabelWithZero, // 👈 Add "All" option first
                ...Party.map(i => ({
                    value: i.id,
                    label: i.Name,
                }))
            ]
            : [allLabelWithZero]; // fallback if Party is empty


    const PartyDrodownOnChange = (e) => {
        setPartyDropdown(e);
        dispatch(GetVenderSupplierCustomer({ subPageMode: url.STOCK_ENTRY_LIST, PartyID: e.value }));

    };

    return (

        <React.Fragment>
            <PageLoadingSpinner isLoading={(goBtnLoading || !pageField)} />
            <div className="page-content">
                <div className="px-3 c_card_filter header text-black mb-1">
                    <Row className="align-items-center">
                        {/* From Date */}
                        <Col sm="3" className="mt-1 mb-1">
                            <FormGroup className="row mt-2">
                                <Label className="col-sm-4 p-2" style={{ width: "83px" }}>From Date</Label>
                                <Col sm="8">
                                    <C_DatePicker
                                        options={{
                                            altInput: true,
                                            altFormat: "d-m-Y",
                                            dateFormat: "Y-m-d",
                                        }}
                                        name='Date'
                                        value={fromdate}
                                        onChange={fromdateOnchange}
                                    />
                                </Col>
                            </FormGroup>
                        </Col>

                        {/* To Date */}
                        <Col sm="3" className="mt-1 mb-1">
                            <FormGroup className="row mt-2">
                                <Label className="col-sm-4 p-2" style={{ width: "65px" }}>To Date</Label>
                                <Col sm="8">
                                    <C_DatePicker
                                        options={{
                                            altInput: true,
                                            altFormat: "d-m-Y",
                                            dateFormat: "Y-m-d",
                                        }}
                                        name='Date'
                                        value={todate}
                                        onChange={todateOnchange}
                                    />
                                </Col>
                            </FormGroup>
                        </Col>

                        {/* Party Dropdown (only for management) */}
                        {IsMannagementParty && (
                            <Col sm="4" className="mt-1 mb-1">
                                <FormGroup className="row mt-2">
                                    <Label className="col-sm-4 p-2" style={{ width: "60px" }}>Party</Label>
                                    <Col sm="8">
                                        <C_Select
                                            name="Party"
                                            value={PartyDropdown}
                                            isSearchable={true}
                                            isLoading={partyDropdownLoading}
                                            className="react-dropdown"
                                            classNamePrefix="dropdown"
                                            styles={{
                                                menu: provided => ({ ...provided, zIndex: 2 })
                                            }}
                                            options={Party_Option}
                                            onChange={PartyDrodownOnChange}
                                        />
                                    </Col>
                                </FormGroup>
                            </Col>
                        )}

                        {/* Go Button */}
                        <Col sm={{ size: 1, offset: IsMannagementParty ? 1 : 5 }} className="mt-1 mb-1 d-flex align-items-center ">
                            <Go_Button
                                loading={goBtnLoading}
                                onClick={(e) => goButtonHandler()}
                            />
                        </Col>
                    </Row>
                </div>

                {pageField && (
                    <div className="mt-n1">
                        <CommonPurchaseList
                            action={action}
                            reducers={reducers}
                            showBreadcrumb={false}
                            MasterModal={StockEntry}
                            masterPath={url.STOCK_ENTRY}
                            newBtnPath={url.STOCK_ENTRY}
                            ButtonMsgLable={"StockEntry"}
                            deleteName={"StockDate"}
                            goButnFunc={goButtonHandler}
                            viewApprovalBtnFunc={viewApprovalBtnFunc}
                        />
                    </div>
                )}
            </div>
            <StockEntryView />
        </React.Fragment>
    )
}

export default StockEntryList;
